import { format, Locale, parse } from 'date-fns'
import { TFunction } from 'i18next'

export const formatLastLesson = (dateStr: string | null | undefined, t: TFunction, dateLocale: Locale): string => {
  if (!dateStr) return t('header.noLessons')
  const parsed = parse(dateStr, 'yyyy-MM-dd', new Date())
  return t('header.lastLesson', { date: format(parsed, 'd MMM yyyy', { locale: dateLocale }) })
}
